module.exports = __webpack_public_path__ + "static/media/Take the tour lovely to see you.f96ee709.mp4";